<template>
  <div v-if="user" class="user-information">
    <span class="user-information__welcome">Hola, {{ fullName }}</span>
    <hr />
    <div class="profile__info">
      <Layout>
        <Column size="5" v-if="userIntegration"> Usuario integración: </Column>
        <Column size="7" v-if="userIntegration">
          <span>{{ userIntegration }}</span>
        </Column>
        <Column size="5"> Organización: </Column>
        <Column size="7">
          <div class="filter__input-dropdown">
            <Dropdown v-if="organization != null">
              <span class="pw-tag" slot="trigger">
                {{ orgDescription }}
                <i class="mdi mdi-chevron-down"></i>
              </span>
              <template>
                <DropdownItem class="search_box">
                  <div class="filter__table">
                    <i class="mdi mdi-magnify"></i>
                    <input type="text" placeholder="Buscar" v-model="filter" />
                  </div>
                  <div v-if="filteredOrgs.length === 0">
                    No hay resultados.
                  </div>
                </DropdownItem>
                <DropdownItem
                  :v-show="true"
                  v-for="(option, index) in filteredOrgs"
                  :key="index"
                  @click="() => selectOrganization(option)"
                >
                  <span class="pw-tag">
                    {{ option.organizationDescription }}
                  </span>
                </DropdownItem>
              </template>
            </Dropdown>
          </div>
        </Column>
        <Column size="5"> Rol: </Column>
        <Column size="7">
          <span>{{ organization.roleName }}</span>
        </Column>
        <Column size="5"> Correo: </Column>
        <Column size="7">
          <span>{{ user.profile.UserName }}</span>
        </Column>
        <Column size="5"> Zona horaria: </Column>
        <Column size="7">
          <span>{{ localIANA }}</span>
        </Column>
      </Layout>
    </div>
    <hr class="profile-separator" />
    <div class="log-out">
      <Button icon="logout" class="custom-button-logout" @click="logOut"> Cerrar sesión </Button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { DateTime } from 'luxon';
import AuthManager from '../utils/AuthManager';
import ApiClient from '../utils/ApiClient';

export default {
  name: 'UserInformation',
  props: {
    closeMenu: {
      type: Boolean,
      default: false,
    },
    organization: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      localIANA: DateTime.local().zoneName,
      organizationsAllowed: [],
      userIntegration: '',
      filter: '',
    };
  },
  mounted() {
    this.getUserOrganizationAllowed();
    this.getUserIntegration();
  },
  methods: {
    getUserOrganizationAllowed() {
      const apiClient = new ApiClient('Configuration/UserOrganizationsAllowed');
      apiClient.Get().then((res) => {
        this.organizationsAllowed = res;
      });
    },
    getUserIntegration() {
      const apiClient = new ApiClient('Configuration/UserIntegrationOrganization');
      apiClient.Get().then((res) => {
        this.userIntegration = res.externalUser;
      });
    },
    logOut() {
      AuthManager.LogOut();
    },
    setOrganization(organization) {
      const apiClient = new ApiClient(
        `Configuration/UserOrganizationActive/${organization.organizationId}`
      );
      apiClient.Put(null).then((res) => {
        if (res.data.operationResult === 1) {
          localStorage.setItem('OCode', organization.organizationCode);
          window.location.href = '/';
        }
        console.log(res.data);
      });
    },
    selectOrganization(option) {
      if (this.organization.organizationId === option.organizationId) {
        return;
      }
      this.showConfirm(
        `¿Deseas cambiar la organización a ${option.organizationDescription}?`,
        'Al cambiarla se refrescará la aplicación ',
        'information',
        [
          {
            text: 'Cancelar',
            callback: () => {},
            props: {
              color: 'terciary-outlined',
            },
          },
          {
            text: 'Aceptar',
            callback: () => {
              this.setOrganization(option);
            },
            props: {
              color: 'secondary-outlined',
            },
          },
        ]
      );
    },
  },
  computed: {
    ...mapState('User', ['user']),
    filteredOrgs() {
      return this.organizationsAllowed.filter((x) => {
        if (this.filter === '') {
          return true;
        }
        const columnsWithFilter = ['organizationCode', 'organizationDescription'];
        return (
          columnsWithFilter
            .map((y) => {
              return String(x[y]).toLowerCase().includes(this.filter.toLowerCase());
            })
            .filter((y) => y).length !== 0
        );
      });
    },
    fullName() {
      if (this.user.profile.UserName) {
        return `${this.user.profile.UserName}`;
      }
      // return `${this.user.profile.FirstName} ${this.user.profile.LastName}`;
      return '';
    },
    orgDescription() {
      return `${
        this.organizationsAllowed.find(
          (obj) => obj.organizationId === this.organization.organizationId
        )?.organizationDescription
      }`;
    },
  },
};
</script>

<style lang="scss">
.log-out {
  text-align: right;
}
.custom-button-logout {
  font-size: 12px !important;
  background-color: #fff !important;
  color: #333 !important;
  border: 0 !important;
  margin-top: 8px;
  padding: 0 !important;
  i {
    font-size: 14px !important;
    cursor: pointer;
  }
}
.user-information {
  min-width: 300px;
  &__welcome {
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 8px;
  }
}
.profile__info {
  margin: 0;
  font-weight: 500;
  font-size: 12px;
  span {
    right: 0;
    text-overflow: ellipsis;
    width: 130px;
    text-align: right;
  }
}

.profile-separator {
  margin-top: 8px;
  margin-bottom: 0;
}

.pw-tag {
  padding: 0 !important;
}

.filter__input {
  //display: flex;
  background-color: #f2f5f8;
  border: 1px solid #d5dbf3;
  padding: 0 8px;
  box-sizing: border-box;
  //position: relative;
  &-icon {
    width: 16px;
    color: #89959e;
    //position: relative;
    margin-right: 8px;
    justify-content: center;
    align-items: center;
    i {
      //position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  &-dropdown {
    //position: absolute;
    top: 50%;
    right: 0px;
    //transform: translateY(-55%);
    .pw-dropdown__content {
      max-height: 26rem;
      overflow-y: scroll;
      overflow-x: hidden;
    }
    ::-webkit-scrollbar {
      width: 8px;
    }
    /* Track */
    ::-webkit-scrollbar-track {
      background: #f1f1f1;
    }
    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #a9a9a9;
    }
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #696969;
    }
  }
  &-input {
    flex: auto;
    input {
      padding: 8px 0;
      background: transparent;
      border: none;
      outline: none;
      width: 100%;
    }
  }
}

.search_box {
  position: sticky;
  top: 0;
  background: white;
}
.pw-dropdown.is-bottom-left .pw-dropdown__menu {
  top: 100%;
  left: -18px !important;
}
</style>
